export const INIT = "basicReport/INIT";
export const SET = "basicReport/SET";
export const SET_ERRORS = "basicReport/SET_ERRORS";

export const initBasicReport = () => ({
  type: INIT
});
export const setBasicReport = res => ({
  type: SET,
  res
});
export const setErrors = errors => ({
  type: SET_ERRORS,
  errors
});

const initialState = {
  totalResultByAttr: [],
  questionRanking: {
    prosData: [],
    consData: []
  },
  correlationCoefficientRanking: {
    firstData: [],
    secondData: []
  },
  errors: []
};

const basicReport = (state = initialState, action) => {
  switch (action.type) {
    case INIT: {
      return {
        ...initialState
      };
    }
    case SET: {
      return { ...action.res };
    }
    case SET_ERRORS: {
      return { ...state, errors: action.errors };
    }
    default:
      return state;
  }
};

export default basicReport;



// WEBPACK FOOTER //
// ./src/redux/modules/basicReport.js